// extracted by mini-css-extract-plugin
module.exports = {"sfaPlayerStatusChip":"sfaPlayerStatusChip_sfaPlayerStatusChip___itv6","icon":"sfaPlayerStatusChip_icon__lgNdE","label":"sfaPlayerStatusChip_label__8_c2W"};